module.exports = __webpack_public_path__ + "img/renzheng_bg.e4efab00.png";